/* global graphql  */
import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header-new'
import Footer from '../components/footer-new'
import HeroVideo from '../components/hero-video'
import VerticalList from '../components/vertical-list'
import Originals from '../components/originals'
import BrandPartnerships from '../components/brand-partnerships'
import CreativeShop from '../components/creative-shop'
import ScrollingBanner from '../components/scrolling-banner'

const IndexPage = ({ data }) => {
  return (
    <div className='wrapper--page-dark page--home'>
      <Helmet title='ATTN:' />
      <Header theme='dark' />
      <div className='hero--fullbleed'>
        <HeroVideo
          desktopVideoSrc={data.homeHero.loop_desktop.file.url}
          mobileVideoSrc={data.homeHero.loop_mobile.file.url}
        />
      </div>
      <div className='home-info'>
        <div className='home-info__body'>
          <div className='home-info__copy'>
          Attention is very hard to get, but we're great at it. We've built a
          business around attention that has engaged massive audiences.
          </div>
          <div className='home-info__stats'>
            <div className='home-info__stat'>
              <span className='home-info__stat-number'>17B</span>
              <span className='home-info__stat-label'>Global views</span>
            </div>
            <div className='home-info__stat'>
              <span className='home-info__stat-number'>8B</span>
              <span className='home-info__stat-label'>Minutes watched</span>
            </div>
            <div className='home-info__stat'>
              <span className='home-info__stat-number'>2.3B</span>
              <span className='home-info__stat-label'>Impressions</span>
            </div>
            <div className='home-info__stat'>
              <span className='home-info__stat-number'>18M</span>
              <span className='home-info__stat-label'>Followers</span>
            </div>
          </div>
        </div>
      </div>
      <ScrollingBanner background='blue' text='Featured work' length={10} />
      <VerticalList verticals={data.allDrupalVertical.edges} />
      <Originals
        desktopImageSrc={data.homeOriginals.image_desktop.url}
        mobileImageSrc={data.homeOriginals.image_mobile.url}
      />
      <BrandPartnerships
        desktopPosterSrc={data.homeBrandPartnerships.image_desktop.url}
        mobilePosterSrc={data.homeBrandPartnerships.image_mobile.url}
        desktopVideoSrc={data.homeBrandPartnerships.loop_desktop.file.url}
        mobileVideoSrc={data.homeBrandPartnerships.loop_mobile.file.url}
      />
      <CreativeShop
        desktopPosterSrc={data.homeCreativeShop.image_desktop.url}
        mobilePosterSrc={data.homeCreativeShop.image_mobile.url}
        desktopVideoSrc={data.homeCreativeShop.loop_desktop.file.url}
        mobileVideoSrc={data.homeCreativeShop.loop_mobile.file.url}
      />
      <Footer />
    </div>
  )
}

export default IndexPage

IndexPage.propTypes = {
  data: PropTypes.object
}

export const query = graphql`
  query IndexPage {
    homeHero: drupalMedia(pid: {eq: "123"}) {
      loop_mobile {
        file {
          url
        }
      }
      loop_desktop {
        file {
          url
        }
      }
    }
    homeOriginals: drupalMedia(pid: {eq: "118"}) {
      image_desktop {
        url
      }
      image_mobile {
        url
      }
    }
    homeBrandPartnerships: drupalMedia(pid: {eq: "119"}) {
      image_desktop {
        url
      }
      image_mobile {
        url
      }
      loop_desktop {
        file {
          url
        }
      }
      loop_mobile {
        file {
          url
        }
      }
    }
    homeCreativeShop: drupalMedia(pid: {eq: "121"}) {
      image_desktop {
        url
      }
      image_mobile {
        url
      }
      loop_desktop {
        file {
          url
        }
      }
      loop_mobile {
        file {
          url
        }
      }
    }
    allDrupalVertical(filter: {weight: {gt: 0}}, sort: {fields: [weight], order: ASC}) {
      edges {
        node {
          id
          label
          title
          description
          platform
          cta {
            title
            url {
              path
            }
          }
          image_desktop {
            url
          }
          image_mobile {
            url
          }
          video_desktop {
            file {
              url
            }
          }
          video_mobile {
            file {
              url
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js